module.exports = __webpack_public_path__ + "img/c03_unitslinger_Normal_ua.fc8606ae.webp";